import React from 'react';
import { useSearchParams, useParams, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import AllProcedures from './SectionsForWorkerProceduresPage/AllProcedures';
import OverdueProcedures from './SectionsForWorkerProceduresPage/OverdueProcedures';
import UnconfirmedReports from './SectionsForWorkerProceduresPage/UnconfirmedReports';
import ProceduresCreatedByAMs from './SectionsForWorkerProceduresPage/ProceduresCreatedByAMs';

import subpageSelection from '../../styles/SubpageSelection.module.css';

const WorkerProcedure = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'all-procedures';

    return (
    <>
        <div className={subpageSelection.panel}>
            <a onClick={() => setSearchParams({ section: 'all-procedures' })} className={`${subpageSelection.buttonToSubPages} ${section === 'all-procedures' ? subpageSelection.active : ''}`}>Все процедуры</a>
            <a onClick={() => setSearchParams({ section: 'overdue-procedures' })} className={`${subpageSelection.buttonToSubPages} ${section === 'overdue-procedures' ? subpageSelection.active : ''}`}>Дела с непредставленным в срок отчётом</a>
            <a onClick={() => setSearchParams({ section: 'unconfirmed-reports' })} className={`${subpageSelection.buttonToSubPages} ${section === 'unconfirmed-reports' ? subpageSelection.active : ''}`}>Непроверенные отчёты</a>
            <a onClick={() => setSearchParams({ section: 'procedures-created-by-ams' })} className={`${subpageSelection.buttonToSubPages} ${section === 'procedures-created-by-ams' ? subpageSelection.active : ''}`}>Карточки, созданные управляющими</a>
        </div>
        <div className='pageWrapper'>
            {section == 'all-procedures' ? <AllProcedures />
            : section == 'overdue-procedures' ? <OverdueProcedures />
            : section == 'unconfirmed-reports' ? <UnconfirmedReports />
            : section == 'procedures-created-by-ams' ? <ProceduresCreatedByAMs />
            : <a>Выберите вкладку</a>}
        </div>
    </>
    )
}

export default WorkerProcedure;